import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import App from "./App";
import Internships from "./Internships";
import Front from "./components/frontend";
import Frontinterns from "./components/frontendintern";
import Fullstack from "./components/fullstack";
import MernStackJobs from "./components/mern";
import MeanStackJobs from "./components/mean";
import NodeJsJobs from "./components/node";
import Phpjobs from "./components/php";
import JobDetails from "./components/details/job-details";

export default function Navigation() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/internships" element={<Internships />} />
        <Route path="/front-end-jobs" element={<Front />} />
        <Route path="/front-end-jobs-interns" element={<Frontinterns />} />
        <Route path="/fullstack-jobs" element={<Fullstack />} />
        <Route path="/mern-stack-jobs" element={<MernStackJobs />} />
        <Route path="/mean-stack-jobs" element={<MeanStackJobs />} />
        <Route path="/node-js-jobs" element={<NodeJsJobs />} />
        <Route path="/php-jobs" element={<Phpjobs />} />
        <Route path="/job-details/:id" element={<JobDetails />} />
      </Routes>
    </Router>
  );
}
